document.addEventListener('click', function (e) {
  if (e.target.classList.contains('accordion-header')) {
    const content = e.target.nextElementSibling;

    if (content.style.display === "none" || content.style.display === "") {
      content.style.display = "block";
      e.target.classList.add("active");
    } else {
      content.style.display = "none";
      e.target.classList.remove("active");
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const variantRadios = document.querySelectorAll('input[name="COLOURS"], input[name="Size"]'); // adjust if using other option names
  const mediaGroups = document.querySelectorAll('[data-media-group]');
  
  function updateMediaDisplay(selectedValue) {
    mediaGroups.forEach(item => {
      const mediaGroup = item.getAttribute('data-media-group');
      if (mediaGroup) {
      if (mediaGroup === selectedValue) {
        item.classList.remove('hide-media');
      } else {
        item.classList.add('hide-media');
      }
      }
    });
  }

  variantRadios.forEach(radio => {
    radio.addEventListener('change', function () {
      const selectedVariantLabel = this.value;
      updateMediaDisplay(selectedVariantLabel);
    });
  });

  // initial run on page load
  const checked = document.querySelector('input[name="COLOURS"]:checked, input[name="Size"]:checked');
  if (checked) updateMediaDisplay(checked.value);
});


var acc = document.getElementsByClassName("mobile-pdp-nav");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}


document.addEventListener('DOMContentLoaded', function() {
                                const buyNowBtn = document.querySelector('.buy-now-button');
                            
                                if (buyNowBtn) {
                                  buyNowBtn.addEventListener('click', function() {
                                    const variantId = buyNowBtn.getAttribute('data-variant-id');
                            
                                    fetch('/cart/clear.js', {
                                      method: 'POST',
                                      headers: {
                                        'Content-Type': 'application/json',
                                        'Accept': 'application/json'
                                      }
                                    }).then(() => {
                                      return fetch('/cart/add.js', {
                                        method: 'POST',
                                        headers: {
                                          'Content-Type': 'application/json',
                                          'Accept': 'application/json'
                                        },
                                        body: JSON.stringify({
                                          id: variantId,
                                          quantity: 1
                                        })
                                      });
                                    }).then(() => {
                                      window.location.href = '/checkout';
                                    });
                                  });
                                }
                              });





/*
 * Product Card Slider
 **/
 


$(document).ready(function() {
  // Initialize sliders
  initializeSliders();

  // Toggle dots based on arrow visibility
  function toggleDots() {
    var arrowsVisible = $('.custom-slider-futured-collection .slick-arrow').is(':visible');
    if (arrowsVisible) {
      $('.custom-slider-futured-collection .slick-dots').show();
    } else {
      $('.custom-slider-futured-collection .slick-dots').hide();
    }
  }

  // Call toggleDots initially
  toggleDots();

  // Call toggleDots on window resize
  $(window).resize(function() {
    toggleDots();
  });

  // Call toggleDots on arrow click (to handle if arrows are dynamically shown/hidden)
  $('.custom-slider-futured-collection .slick-arrow').click(function() {
    toggleDots();
  });

  // Initialize all sliders after a delay
  function initializeSliders() {
    setTimeout(function() {
      // Common responsive settings
      var commonResponsiveSettings = [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          infinite: true,
          centerMode: false
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          infinite: true,
          autoplay: false,
          autoplaySpeed: 2000,
          centerMode: false
        }
      }];

      // Initialize .slick-slider-product-img slider
      $('.slick-slider-product-img').each(function () {
      const $slider = $(this);
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        dots: true,
        infinite: false,
        centerMode: false,
        responsive: commonResponsiveSettings
        });
      }
    });
      

    

      // Custom arrows for recently-viewed-new slider
      var nextArrowHTML = '<a class="slick-arrow slick-next"><svg width="35" height="45" viewBox="0 0 35 45" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="34" height="44" stroke="black"/><path d="M15 31L22.5 22.5L15 13.5" stroke="#2D2926" stroke-width="2" stroke-linecap="round"/</svg></a>';
      var prevArrowHTML = '<a class="slick-arrow slick-prev"><svg width="35" height="45" viewBox="0 0 35 45" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="35" height="45" fill="white"/><rect x="0.5" y="0.5" width="34" height="44" stroke="black"/><g clip-path="url(#clip0_4750_794)"><path d="M20 13L12.5 21.5L20 30.5" stroke="#2D2926" stroke-width="2" stroke-linecap="round"/></g><defs><clipPath id="clip0_4750_794"><rect width="20" height="20" fill="white" transform="translate(26 32) rotate(-180)"/></clipPath></defs></svg></a>';

      
    }, 1000);
  }
});


 document.querySelectorAll('.js-variant-swatch-item').forEach(button => {
    button.addEventListener('click', function () {
      const mediaId = this.dataset.mediaId;
      const productId = this.dataset.productId;
      const slider = document.querySelector(`.slick-slider-product-img[data-product-id="${productId}"]`);

      if (!mediaId || !slider) return;

      const slides = slider.querySelectorAll('[data-media-id]');
      slides.forEach((slide, index) => {
        if (slide.dataset.mediaId === mediaId) {
          $(slider).slick('slickGoTo', index);
        }
      });
    });
  });

function enableRecentlyViewedVariantSwitcher() {
  const recentlyViewedSection = document.querySelector('recently-viewed-products');
  if (!recentlyViewedSection) return;

  recentlyViewedSection.querySelectorAll('.js-variant-swatch-item').forEach(button => {
    button.addEventListener('click', () => {
      const mediaId = button.dataset.mediaId;
      const productId = button.dataset.productId;
      const slider = recentlyViewedSection.querySelector(`.slick-slider-product-img[data-product-id="${productId}"]`);

      if (!slider || !mediaId) return;

      const slides = slider.querySelectorAll('[data-media-id]');
      let targetIndex = -1;

      slides.forEach((slide, index) => {
        if (slide.dataset.mediaId === mediaId) {
          targetIndex = index;
        }
      });

      if (targetIndex >= 0 && $(slider).hasClass('slick-initialized')) {
        $(slider).slick('slickGoTo', targetIndex);
      }
    });
  });
}




document.addEventListener("DOMContentLoaded", function () {
  const langBox = document.querySelector(".language-selector-custom");
  const button = document.querySelector(".language-toggle");

  if (button && langBox) {
    button.addEventListener("click", function () {
      langBox.classList.toggle("open");
    });

    document.addEventListener("click", function (e) {
      if (!langBox.contains(e.target)) {
        langBox.classList.remove("open");
      }
    });
  }
});